import { jsx as _jsx } from "react/jsx-runtime";
import { Text, useLocalizeMessage } from 'libs.nucleus';
export const DashboardEmptyState = () => {
    const translate = useLocalizeMessage();
    return (_jsx("div", { className: 'rounded-lg bg-neutral-50 p-6', children: _jsx("div", { className: 'flex items-center justify-center rounded-lg border border-dashed border-neutral-300 py-24', children: _jsx(Text, { size: 'sm', className: 'text-neutral-500', children: translate('Select a study and environment, then click Run to preview the dashboard.') }) }) }));
};
